import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-confirm-email',
    imports: [RouterLink, MatButtonModule],
    templateUrl: './confirm-email.component.html',
    styleUrl: './confirm-email.component.scss'
})
export class ConfirmEmailComponent implements OnDestroy {
    private destroy$ = new Subject<void>();

    // isToggled
    isToggled = false;

    constructor(
        public themeService: CustomizerSettingsService
    ) {
        this.themeService.isToggled$.pipe(takeUntil(this.destroy$)).subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }

}
